/**
 * Domain model for `/businesses/analytics/ratings`.
 *
 * Reads BOTH camelCase (current BE wire format) and snake_case (future-
 * proof in case ClassSerializerInterceptor is enabled).
 */

const pick = (obj, ...keys) => {
  for (const k of keys) {
    if (obj && obj[k] !== undefined) return obj[k];
  }
  return undefined;
};

export class AnalyticsRatings {
  constructor(data = {}) {
    this.distribution = (data.distribution || []).map(d => ({
      grade: d.grade,
      count: d.count ?? 0
    }));

    this.trend = (data.trend || []).map(p => ({
      date: p.date,
      avgGrade: pick(p, "avgGrade", "avg_grade") ?? 0,
      count: p.count ?? 0
    }));

    const ranking =
      pick(data, "technicianRanking", "technician_ranking") || [];
    this.technicianRanking = ranking.map(t => ({
      employeeId: pick(t, "employeeId", "employee_id"),
      firstName: pick(t, "firstName", "first_name"),
      lastName: pick(t, "lastName", "last_name"),
      servicesCount: pick(t, "servicesCount", "services_count") ?? 0,
      avgGrade: pick(t, "avgGrade", "avg_grade"),
      reviewsCount: pick(t, "reviewsCount", "reviews_count") ?? 0
    }));

    const lows = pick(data, "recentLowRatings", "recent_low_ratings") || [];
    this.recentLowRatings = lows.map(r => ({
      reviewId: pick(r, "reviewId", "review_id"),
      serviceId: pick(r, "serviceId", "service_id"),
      grade: r.grade,
      comment: r.comment,
      driverFirstName: pick(r, "driverFirstName", "driver_first_name"),
      driverLastName: pick(r, "driverLastName", "driver_last_name"),
      technicians: r.technicians || [],
      serviceTypeId: pick(r, "serviceTypeId", "service_type_id"),
      createdAt: pick(r, "createdAt", "created_at")
    }));
  }
}
